/** Install / Add to Home Screen decision. The banner stays quiet when the app is already standalone. */

export const INSTALL_DISMISS_KEY = "ns.companion.installDismissed";

export type InstallSurface = "hidden" | "prompt" | "ios";

export type InstallSnapshot = {
  standalone: boolean;
  dismissed: boolean;
  /** Chromium fired `beforeinstallprompt` and we held it for our button. */
  canPrompt: boolean;
  /** iPhone / iPad, where the install prompt event does not exist. */
  ios: boolean;
};

export type BeforeInstallPromptLike = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

export function installSurface(input: InstallSnapshot): InstallSurface {
  if (input.standalone || input.dismissed) return "hidden";
  if (input.canPrompt) return "prompt";
  if (input.ios) return "ios";
  return "hidden";
}

export function isStandaloneDisplay(input: { navigatorStandalone?: boolean; displayModeStandalone: boolean }): boolean {
  return Boolean(input.navigatorStandalone) || input.displayModeStandalone;
}

/**
 * iOS Safari (and other iOS browsers, which are WebKit) have no `beforeinstallprompt`.
 * iPadOS often sends a Macintosh UA with a touch screen.
 */
export function isIosInstallTarget(ua: string, touchPoints = 0): boolean {
  if (/Android/i.test(ua)) return false;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return /\bMacintosh\b/.test(ua) && touchPoints > 1;
}
